import * as togpx from "@tmcw/togeojson";

export const convertKmlToGeojson = async (file: File) => {
  const kmlContent = await file.text();
  const kmldom = new DOMParser().parseFromString(kmlContent, "text/xml");
  const geojson = togpx.kml(kmldom);

  return geojson;
};
